import React from "react";
import { Input, MenuItem, Select, InputLabel, Paper, Grid, Typography } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import useStyles from "./styles";
import GridByDay from '../../components/GridByDay/gridByDay';
import DateFnsUtils from '@date-io/date-fns';
import { filterOptionsArray } from "../../components/Utils/filters";
import { moment } from "../../components/Utils/momentConfig";
import { momentFormat } from "../../components/Utils/formatters";

import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function Dashboard(props) {
  const [open, setOpen] = React.useState(true);
  
  var classes = useStyles();

  const setInitialDateHelper = addDaysValue => {
    const date = moment().add(addDaysValue, 'days');
    const returnDate = moment(date).format(momentFormat)
    setInitialDate(returnDate);
    return returnDate;
  };

  const setEndDateHelper = addDaysValue => {
    const date = moment().add(addDaysValue, 'days');
    const returnDate = moment(date).format(momentFormat)
    setEndDate(returnDate);
    return returnDate;
  };

  const [initialDate, setInitialDate] = React.useState(moment().subtract(7, 'days').format(momentFormat));
  const handleInitialDateChange = date => { setInitialDate(date); };
  const [endDate, setEndDate] = React.useState(moment().subtract(1, 'days').format(momentFormat));
  const handleEndateChange = date => { setEndDate(date); };

  const [dateTypeFilter, setDateTypeFilter] = React.useState("Last7Days");
  const handleDateTypeChange = value => {
    const myButtonType = value && value.target ? value.target.value : "";
    setDateTypeFilter(myButtonType);
    
    if (myButtonType === "ThisMonth") {
      const initialDate = moment().add(1, 'days').startOf('month').format(momentFormat);
      const endDate = moment().add(1, 'days').endOf('month').format(momentFormat);
      setInitialDate(moment(initialDate));
      setEndDate(moment(endDate));
    }
    else if (myButtonType === "LastMonth") {
      const initialDate = moment().subtract(1, 'month').startOf('month').format(momentFormat);
      const endDate = moment().subtract(1, 'month').endOf('month').format(momentFormat);
      setInitialDate(moment(initialDate));
      setEndDate(moment(endDate));
    }
    else
    {
      var option = filterOptionsArray.filter((dateType) => 
      { 
        return dateType.id === myButtonType; 
      });
      if(option && option[0])
      {
        setInitialDateHelper(option[0].initialValueCalc);
        setEndDateHelper(option[0].endValueCalc);
      }
    }
  }

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Typography variant="h2" style={{ marginBottom: '9px' }}>Dashboard</Typography>
        </Grid>
        <Grid item xs={8}>
          <Paper className={classes.paper}>
            <div className={classes.root}>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <InputLabel className={classes.marginText}>Initial Date</InputLabel>
                    <KeyboardDatePicker disableToolbar variant="inline" format="yyyy-MM-dd" margin="normal" id="date-picker-inline1" style={{ width: '100%' }}
                      value={moment(initialDate)} onChange={handleInitialDateChange} KeyboardButtonProps={{ "aria-label": "change date" }} className={classes.marginDefault}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={4}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <InputLabel className={classes.marginText}>End Date</InputLabel>
                    <KeyboardDatePicker disableToolbar variant="inline" format="yyyy-MM-dd" margin="normal" id="date-picker-inline2" style={{ width: '100%' }}
                      value={moment(endDate)} onChange={handleEndateChange} KeyboardButtonProps={{ "aria-label": "change date" }} className={classes.marginDefault}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={4}>
                  <InputLabel className={classes.marginText}>Date Types</InputLabel>
                  <Select
                    id="dateTypeFilter-lookup-id"
                    label="Date Helper"
                    value={dateTypeFilter}
                    onChange={handleDateTypeChange}
                    input={<Input />}
                    className={classes.marginDefault}
                    style={{ width: '95%' }}
                  >
                    {filterOptionsArray.map(item => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>))
                    }
                  </Select>
                </Grid>
              </Grid>
            </div>
          </Paper>
          <Grid xs={12}>
          <Collapse in={open}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="primary"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              color="warning"
              severity="warning"
              style={{marginTop: '10px'}}
            >
              Data can be delayed for many hours
            </Alert>
            </Collapse>
          </Grid>
        </Grid>
      </Grid>
      <br />
      <GridByDay initialDate={initialDate} endDate={endDate} publisherId={localStorage.getItem('publisher-active')} isDashboard={true}
        networkPublishers={[localStorage.getItem('publisher-active')]} network={""}></GridByDay>
    </>
  );
}